
import ButtonBase from '@mui/material/ButtonBase'
import Grid2 from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'

import styles from "./versionChecker.module.css"

const VersionContent = () => {
    const handleClick = () => {
        window.location.reload()
    }
    return (
        <Grid2 className={styles.content}  >
            <Typography variant='ingredientText2paralellOutfit' >
                New update available!
            </Typography>
            <ButtonBase className={styles.refresh} onClick={handleClick} >Refresh</ButtonBase>
        </Grid2>
    )
}

export default VersionContent
